import { render, staticRenderFns } from "./RightColumnQnASettings.vue?vue&type=template&id=20d1a05e&scoped=true&"
import script from "./RightColumnQnASettings.vue?vue&type=script&lang=js&"
export * from "./RightColumnQnASettings.vue?vue&type=script&lang=js&"
import style0 from "./RightColumnQnASettings.vue?vue&type=style&index=0&id=20d1a05e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d1a05e",
  null
  
)

export default component.exports